const quotes = [
  {
    text: '“Vse hudo nas še čaka, na drugi val se moramo veliko bolj resno pripraviti.”',
    person: 'vladni govorec Jelko Kacin',
    reference: {
      label: 'Svet24',
      link: 'https://novice.svet24.si/clanek/novice/slovenija/5eb24b54b83e1/jelko-kacin-vse-hudo-nas-se-caka-na-drugi-val-se-moramo-veliko-bolj-resno-pripraviti',
    },
  },
  // {
  //   text: '“The greatest glory in living lies not in never falling, but in rising every time we fall.”',
  //   person: 'Nelson Mandela',
  //   reference: {
  //     label: 'lorem ipsum',
  //     link: 'https://www.google.com/',
  //   },
  // },
  // {
  //   text: '“The way to get started is to quit talking and begin doing.”',
  //   person: 'Walt Disney',
  //   reference: {
  //     label: 'lorem ipsum',
  //     link: 'https://www.google.com/',
  //   },
  // },
  // {
  //   text: '“Your time is limited, so don\'t waste it living someone else\'s life. Don\'t be trapped by dogma – which is living with the results of other people\'s thinking.”',
  //   person: 'Steve Jobs',
  //   reference: {
  //     label: 'lorem ipsum',
  //     link: 'https://www.google.com/',
  //   },
  // },
  // {
  //   text: '“If you look at what you have in life, you\'ll always have more. If you look at what you don\'t have in life, you\'ll never have enough.”',
  //   person: 'Oprah Winfrey',
  //   reference: {
  //     label: 'lorem ipsum',
  //     link: 'https://www.google.com/',
  //   },
  // },
];

export default quotes;
